export enum govevaLinks {
    dashboard = "dashboards/director-view",
    legacyDashboard = "dashboards/alpha",
    rolemaster = "role-master/roleMaster",
    userMaster = "userMaster/userManagement",
    companyMaster = "companymaster",
    structure = "structure"
}